import { useEffect, useState } from "react";
import { AppEntities } from "src/config/entities";
import { TypeHelper } from "src/helpers/TypeHelper";
import { toast } from "react-toastify";
import { IDistributionOfLandedCostsDto } from "../dtos/IDistributionOfLandedCostsDto";
import { IDistributionOfLandedCostsModel } from "../models/IDistributionOfLandedCostsModel";
import { DistributionOfLandedCostsService } from "src/services/documents/DistributionOfLandedCostsService";
import { IDistributionOfLandedCostsVendorInvoiceModel } from "../models/IDistributionOfLandedCostsVendorInvoiceModel";
import { IDistributionOfLandedCostsExpenseModel } from "../models/IDistributionOfLandedCostsExpenseModel";
import { IDistributionOfLandedCostsProductModel } from "../models/IDistributionOfLandedCostsProductModel";

interface IProps {
  documentId?: string;
}

 const useFetchDistributionOfLandedCosts = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<IDistributionOfLandedCostsDto | null>(null);
  const [documentModel, setDocumentModel] = useState<IDistributionOfLandedCostsModel | null>(null);
  const dataService = AppEntities.DistributionOfLandedCosts.getDataService() as DistributionOfLandedCostsService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: IDistributionOfLandedCostsModel) => {
    if (!documentId) return;
    //@ts-ignore
    const requestDto: IDistributionOfLandedCostsDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
    // toast.success("Document updated successfully");
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);

      console.log("documentId", documentId);

      let responseDto: IDistributionOfLandedCostsDto | null = null;
      let responseVendorInvoicesDto: IDistributionOfLandedCostsVendorInvoiceModel[] = [];
      let responseExpensesDto: IDistributionOfLandedCostsExpenseModel[] = [];
      let responseProductsDto: IDistributionOfLandedCostsProductModel[] = [];

      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: IDistributionOfLandedCostsModel = {
        ...responseDto,
        vendorInvoices: [...responseVendorInvoicesDto],
        expenses: [...responseExpensesDto],
        products: [...responseProductsDto]
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
export default useFetchDistributionOfLandedCosts